import React from 'react';

import { LazyTeamCalendars, CALENDAR_CONTEXT } from '@confluence/team-calendar';

export const EmbeddedMultipleCalendarRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS({ spaceKey }: { spaceKey: any }): {
		Screen: {
			screenEvent: {
				name: string;
				id: any;
			};
			pageState: {
				spaceKey: any;
			};
		};
		MainLayout: {
			enableNavigation: boolean;
			spaceKey: any;
		};
	};
} = (): React.JSX.Element => {
	return <LazyTeamCalendars calendarContext={CALENDAR_CONTEXT.EMBEDDED_MULTIPLE_CALENDARS} />;
};

EmbeddedMultipleCalendarRoute.NAVIGATION_PARAMS = ({ spaceKey }) => ({
	Screen: {
		screenEvent: {
			name: 'embeddedMultipleCalendarsScreen',
			id: spaceKey,
		},
		pageState: { spaceKey },
	},

	MainLayout: {
		enableNavigation: false,
		spaceKey,
	},
});
